import React, { useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import WcIcon from '@material-ui/icons/Wc';

import useStyles from "./Page7.style";

const Page7 = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [sexualPreference, setSexualPreference] = useState('');

    useEffect(() => {
        const localStorageSexualPreference = localStorage.getItem('sexualPreference');
        const propsSexualPreference = props.profile && props.profile.sexualPreference;
        const storedSexualPreference = localStorageSexualPreference || propsSexualPreference;

        if (storedSexualPreference) setSexualPreference(storedSexualPreference);
    }, [props.profile]);

    const handleSexualPreferenceChange = (event, newValue) => {
        setSexualPreference(newValue);
        localStorage.setItem('sexualPreference', newValue);
    };

    return (
        <>
            <Box className={classes.iconSection}>
                <WcIcon className={classes.icon} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('repliQuestionnaire.general.sexualPreferenceQuestion')}
                </Typography>
            </Box>
            <Box className={classes.inputSection}>
                <FormControl component="fieldset">
                    <RadioGroup aria-label="Sexual Preference" value={sexualPreference} onChange={handleSexualPreferenceChange}>
                        <FormControlLabel value="male" control={<Radio />} label={t('common.substantive.male')} />
                        <FormControlLabel value="female" control={<Radio />} label={t('common.substantive.female')} />
                        <FormControlLabel value="both" control={<Radio />} label={t('common.substantive.both')} />
                        <FormControlLabel value="notSexuallyActive" control={<Radio />} label={t('repliQuestionnaire.label.sexualPreference.notSexuallyActive')} />
                    </RadioGroup>
                </FormControl>
            </Box>
        </>
    );
};

export default Page7;